import { createContext, FC, PropsWithChildren } from "react";
import { ISidePanel, SidePanel, useSidePanel } from "../../ui/side-panel/side-panel";

export const sidePanelContext = createContext<ISidePanel>({
    isOpen: false,
    close: () => {
    },
    openSidePanel: () => {
    },
    panelPosition: "left",
    panelSize: 500,
    showCloseBtn: true
});

interface ISidePanelProviderProps extends PropsWithChildren {
}

export const SidePanelProvider: FC<ISidePanelProviderProps> = ({ children }) => {
    const sidePanelValue = useSidePanel();
    return <sidePanelContext.Provider value={sidePanelValue}>
        <SidePanel/>
        {children}
    </sidePanelContext.Provider>;
};
